<template>
    <v-card id="insurancecompany">
        <v-container fluid>
            <p class="headline">保險公司資訊管理</p>
            <v-row>
                <v-col cols="4">
                    <insurance-company-combo 
                        v-model="insuranceCompany" 
                        :items='this.insuranceCompanies'
                        label="保險公司">
                    </insurance-company-combo >
                </v-col>
            </v-row>
        </v-container>
        <v-row>
            <v-col>
                <insurance-company-information-data-table :insurance_company_id="selectedCompany"></insurance-company-information-data-table>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
//定義資料服務類別
import CommonDataService from '../../services/CommonDataService'

//定義介面元件
import InsuranceCompanyCombo from '../../components/InsuranceCompanyCombo'
import InsuranceCompanyInformationDataTable from '../../components/InsuranceCompany/InsuranceCompanyInformationDataTable'

export default {
    components:{
        InsuranceCompanyCombo,
        InsuranceCompanyInformationDataTable
    },
    data(){
        return {
           insuranceCompany:{id:-1, name:'', insurance_products:[]}, //v-model for 保險公司
           insuranceCompanies:[], //從API取的的保險公司＋商品資料，要注入至保險公司元件
        }
    },
    computed:{
        selectedCompany(){
            return this.insuranceCompany.id
        }
    },
    created(){
        this.findInsuranceCompanies()
    },

    methods:{
        findInsuranceCompanies(){
            CommonDataService.findInsuranceCompanies().then((response)=>{
                this.insuranceCompanies = response.list
            }).catch(function (error) {
                console.log(error)
            })
        }
    }
}
</script>
